module.exports = __webpack_public_path__ + "static/img/15.d6585d7d.png";